import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { Modal, Select } from "flowbite-react";
import { useEmployeers } from "../hooks";
import { useState } from "react";
import { updateInventoryManagement } from "@/common/services/Inventory-management.api";
import { IinventoryManagement } from "@/types/inventory-management.type";

export const ModalLinkEmployeer = ({
  inventoryManagement,
  onClose,
}: {
  inventoryManagement: IinventoryManagement;
  onClose: () => void;
}) => {
  const [employeerId, setEmployeerId] = useState<string | undefined>();
  const { data } = useEmployeers();

  const employeersList = data?.map((employee) => ({
    value: employee._id ?? "",
    label: employee.name ?? "",
  }));

  const handleSelectedEmployeer = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const id = event.target.value;
    setEmployeerId(id);
  };

  const onSave = async () => {
    try {
      await updateInventoryManagement({
        _id: inventoryManagement?._id,
        employeerId,
      });

      onClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal show={true} onClose={onClose}>
      <Modal.Header className="text-black">
        <h2 className="dark:text-black">Vincular colaborador</h2>
      </Modal.Header>
      <Modal.Body className="text-black">
        <Select
          className="mt-4"
          name="employee"
          onChange={(event) => handleSelectedEmployeer(event)}
          required
        >
          {employeersList?.map((employee) => (
            <option key={employee.value} value={employee.value}>
              {employee.label}
            </option>
          ))}
        </Select>
      </Modal.Body>
      <Modal.Footer className="justify-end h-16 pb-8">
        <ButtonWithLoader type="button" onClick={onSave}>
          Salvar
        </ButtonWithLoader>
      </Modal.Footer>
    </Modal>
  );
};
